<script>
  export default {
    functional: true,

    name: 'UiCardSubtitle',

    render (h, {data, children} ) {
      const staticClass = 'card-subtitle';
      data.staticClass = data.staticClass ? `${data.staticClass} ${staticClass}` : staticClass

      return h('h3', {
        ...data
      }, children)
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/UiCardSubtitle.vue